import { render, staticRenderFns } from "./TestEndEmoji.vue?vue&type=template&id=392d6afc&scoped=true"
import script from "./TestEndEmoji.vue?vue&type=script&lang=ts"
export * from "./TestEndEmoji.vue?vue&type=script&lang=ts"
import style0 from "./TestEndEmoji.vue?vue&type=style&index=0&id=392d6afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d6afc",
  null
  
)

export default component.exports